export const cs = {
    translation: {
        minimumStayDetail: {
            minimum_one: 'Garáž má minimální délku rezervace {{count}}\u00a0hodinu.',
            minimum_few: 'Garáž má minimální délku rezervace {{count}}\u00a0hodiny.',
            minimum_many: 'Garáž má minimální délku rezervace {{count}}\u00a0hodiny.',
            minimum_other: 'Garáž má minimální délku rezervace {{count}}\u00a0hodin.',
            until: 'Můžete proto parkovat až do {{endsAt}}.',
            untilMidnight: 'Můžete proto parkovat až do půlnoci.',
            untilWeekday: 'Můžete proto parkovat až do {{weekday}} {{endsAt}}.',
        },
        minimumStayPrice: {
            unavailable: 'Cenu se nepodařilo načíst. Zkuste to prosím znovu.',
            availabilityUnavailable: 'Dostupnost se nepodařilo ověřit. Zkuste to prosím znovu.',
            duration_one: 'Cena za {{count}} hodinu.',
            duration_few: 'Cena za {{count}} hodiny.',
            duration_many: 'Cena za {{count}} hodiny.',
            duration_other: 'Cena za {{count}} hodin.',
            until: 'Můžete parkovat až do {{endsAt}}.',
            untilMidnight: 'Můžete parkovat až do půlnoci.',
            untilWeekday: 'Můžete parkovat až do {{weekday}} {{endsAt}}.',
            weekdays: {
                0: 'neděle',
                1: 'pondělí',
                2: 'úterý',
                3: 'středy',
                4: 'čtvrtka',
                5: 'pátku',
                6: 'soboty',
            },
        },
        general: {
            bookNow: 'Rezervovat',
            bookNowFor: 'Rezervovat za',
            cannotBook: 'Nelze rezervovat',
            unavailable: 'Nedostupné',
            someGaragesInvalidPeriod: 'Některé garáže nelze pro zvolený termín rezervovat:',
            detail: 'Detail',
            czk: 'Kč',
            occupied: 'Garáž plná',
            occupiedShort: 'Plná',
            min: 'Min.',
            hours: 'hod.',
            hoursShortcut: 'hod',
            list: 'Seznam',
            map: 'Mapa',
            filters: 'Filtry',
            hide: 'Skrýt',
            garagesFound_one: 'Nalezena <strong>{{count}} lokalita</strong>',
            garagesFound_few: 'Nalezeny <strong>{{count}} lokality</strong>',
            garagesFound_many: 'Nalezeno <strong>{{count}} lokalit</strong>',
            garagesFound_other: 'Nalezeno <strong>{{count}} lokalit</strong>',
            garagesAvailableLaterGeneric: 'Zdá se, že v tomto čase je hodně lokalit obsazených. Posuňte začátek rezervace na <strong>{{from}} - {{to}}</strong> a bude dostupných více lokalit.',
            garagesAvailableAtTime_one: 'Zdá se, že v tomto čase je hodně lokalit obsazených. Posuňte začátek rezervace na <strong>{{time}}</strong> a bude dostupných o <strong>{{count}} lokalitu více</strong>.',
            garagesAvailableAtTime_few: 'Zdá se, že v tomto čase je hodně lokalit obsazených. Posuňte začátek rezervace na <strong>{{time}}</strong> a bude dostupných o <strong>{{count}} lokality více</strong>.',
            garagesAvailableAtTime_many: 'Zdá se, že v tomto čase je hodně lokalit obsazených. Posuňte začátek rezervace na <strong>{{time}}</strong> a bude dostupných o <strong>{{count}} lokalit více</strong>.',
            garagesAvailableAtTime_other: 'Zdá se, že v tomto čase je hodně lokalit obsazených. Posuňte začátek rezervace na <strong>{{time}}</strong> a bude dostupných o <strong>{{count}} lokalit více</strong>.',
            moveToTimeWithCount_one: 'Posunout na {{time}} (+{{count}} lokalita)',
            moveToTimeWithCount_few: 'Posunout na {{time}} (+{{count}} lokality)',
            moveToTimeWithCount_many: 'Posunout na {{time}} (+{{count}} lokalit)',
            moveToTimeWithCount_other: 'Posunout na {{time}} (+{{count}} lokalit)',
            fromTime: 'Od {{time}}',
            moveToTime: 'Posunout na {{time}}',
            setStartToTime: 'Posunout začátek na {{time}}',
            startTimeMoved: 'Začátek rezervace posunut na {{time}}',
            undo: 'Vrátit',
            garageAvailableLaterDetail: 'Tato garáž má dostupnou kapacitu od {{time}}.',
            close: 'Zavřít',
            lastPlacesAvailable: 'Poslední místa',
            boolean: {
                true: 'Ano',
                false: 'Ne'
            },
            phoneInput: { // intl-tel-input
                searchPlaceholder: "Zvolte předvolbu",
            },
            resetChanges: 'Zrušit změny',
            confirmFormClear: 'Potvrdit vymazání formuláře',
            cancel: 'Zrušit',
            confirm: 'Potvrdit',
        },
        filters: {
            showAvailable: 'Zobrazit pouze dostupné garáže',
            yesShow: 'Ano',
            priceRange: 'Cenové rozpětí',
            carHeight: 'Výška vašeho vozidla',
            carWidth: 'Šířka vašeho vozidla',
            carLength: 'Délka vašeho vozidla',
            carWeight: 'Hmotnost vašeho vozidla',
            sortBy: 'Řadit dle',
            distance: 'Vzdálenost',
            price: 'Cena',
            parkingType: 'Typ',
            all: 'Vše',
            garage: 'Garáž',
            parkingLot: 'Parkoviště',
            restrictions: 'Zobrazit pouze garáže kde jsou povoleny',
            electricAllowed: 'Elektromobily',
            lpgCngAllowed: 'LPG & CNG',
            motorbikesAllowed: 'Motorky',
            remove: 'Zrušit všechny filtry',
            reset: 'Resetovat filtry',
            showResults: 'Zobrazit výsledky',
            noResultsMatch: 'Zadaným parametrům neodpovídají žádné garáže.',
        },
        search: {
            reset: 'Resetovat',
            edit: 'Upravit',
            search: 'Hledat',
            where: 'Kde chcete zaparkovat?',
            wherePlaceholder: 'Město, ulice, místo...',
            whereEmpty: 'Žádné návrhy',
            start: 'Začátek',
            end: 'Konec',
            label: 'Kdy a kde chcete parkovat?',
            reservationStart: 'Začátek rezervace',
            reservationEnd: 'Konec rezervace',
            reservationLength: 'Délka rezervace',
            pricePerHour: 'Cena / hod.',
            reservationExtendedLength: 'Délka prodloužené rezervace',
            reservationDate: 'Termín rezervace',
            days_one: ' {{count}} den',
            days_few: ' {{count}} dny',
            days_many: ' {{count}} dní',
            days_other: ' {{count}} dní',
            hours_one: ' {{count}} hodina',
            hours_few: ' {{count}} hodiny',
            hours_many: ' {{count}} hodin',
            hours_other: ' {{count}} hodin',
            minutes_one: ' {{count}} minuta',
            minutes_few: ' {{count}} minut',
            minutes_many: ' {{count}} minut',
            minutes_other: ' {{count}} minut',
            selectDate: 'Vyberte datum začátku a konce',
            arrivalAfter: 'Příjezd po',
            departureBefore: 'Odjezd před',
            selectStart: 'Vyberte v kalendáři datum začátku rezervace',
            selectEnd: 'Vyberte v kalendáři datum konce rezervace',
            startInThePast: 'Začátek vaší rezervace je v minulosti!',
            discountAvailable: 'Rezervujte alespoň 7 dní a získejte <strong>slevu 15%</strong> s kódem <strong>PREMIUM7</strong>.',
            // discountAvailableCustom: 'Při rezervaci delší než 1 měsíc získejte nabídku na míru na <a href="mailto:info@mrparkit.com">info@mrparkit.com</a>.',
            invalidTimeRange: 'Vyberte platný termín s koncem po začátku rezervace.',
            defaultLocation: 'Parkování v Praze',
            selectExtensionStart: 'Vyberte v kalendáři datum nového ZAČÁTKU rezervace (případně zvolte stejný den).',
            selectExtensionEnd: 'Vyberte v kalendáři datum nového KONCE rezervace (případně zvolte stejný den).',
            extensionStartsTooLate: 'Zvolený začátek prodloužení nesmí být později než začátek rezervace.',
            extensionEndsTooEarly: 'Zvolený konec prodloužení nesmí být dříve než konec rezervace.',
            extensionIntoThePast: 'Rezervaci nelze prodloužit do minulosti.',
            checkAvailability: 'Zjistit dostupnost',
            sendExtensionRequest: 'Odeslat žádost o prodloužení',
            return: 'Zpět',
            extendReservation: 'Prodloužit rezervaci',
            extensionPossible: 'Vaši rezervaci je možné prodloužit!',
            extensionPrice: 'Cena prodloužení: {{price}} CZK',
            originalExtensionPrice: 'Původní cena prodloužení',
            extensionTotal: 'Celkem za prodloužení',
            payToContinue: 'Pro potvrzení prodloužení prosím proveďte úhradu rozdílu.',
            toPaymentCTA: 'Uhradit',
        },
        routes: {
            garages: 'garaze',
            reservations: 'rezervace',
            reservations_steps: {
                reservation_time: 'cas-rezervace',
            },
            users: 'uzivatele',
            signIn: 'prihlaseni',
            register: 'registrace',
            signOut: 'odhlasit',
        },
        reservations: {
            status: {
                booked: 'Budoucí',
                current: 'Probíhající',
                elapsed: 'Již proběhlá',
                cancelled: 'Zrušená',
                allocated: 'Alokovaná',
            },
            general: {
                active: 'Probíhající rezervace',
                all: 'Všechny rezervace',
                noBooked: 'Nemáte žádnou probíhající ani budoucí rezervaci.',
                noBookedCreate: 'Vytvořit rezervaci',
                remaining: 'Zbývá',
            },
            filters: {
                sortBy: 'Řazení',
                id: 'ID',
                startAt: 'Začátek rezervace',
                status: 'Filtr stavu',
                all: 'Všechny',
                active: 'Probíhající',
                elapsed: 'Proběhlé',
                cancelled: 'Zrušené',
                allocated: 'Alokované',
            },
            table: {
                reservation: 'Rezervace',
                garage: 'Garáž',
                unit: 'Místo',
                driver: 'Řidič',
                licensePlate: 'SPZ',
                phone: 'Telefon',
                date: 'Termín',
                price: 'Cena',
                createdAt: 'Vytvořeno',
                garageAndUnit: 'Garáž a místo',
                from: 'Od',
                to: 'Do',
                phoneNumbers: 'Tel. čísla',
                cancelReservation: 'Stornovat',
                editDetails: 'Upravit SPZ/telefon',
                bookNextDay: 'Zopakovat rezervaci další den',
                bookTomorrow: 'Zopakovat rezervaci od zítra',
                bookAgain: 'Vytvořit rezervaci ve stejné garáži',
                paymentInProgress: 'Platba je právě zpracovávána. Prosím vyčkejte na potvrzení.',
                changeUnitApprove: 'Pro dokončení změny parkovacího místa prosím potvrďte provozní řád garáže.',
                confirm: 'Potvrdit',
                openGarage: 'Detail garáže'
            },
            unpaid: {
                unfinishedReservation: {
                    alert: 'Pro dokončení rezervace pokračujte k platbě.',
                    button: 'K platbě',
                },
                prolongation: {
                    alert: 'Pro dokončení prodloužení rezervace prosím uhraďte {{price}} {{currency}}.',
                    button: 'Uhradit prodloužení',
                },
                changeUnit: {
                    alert: 'Pro dokončení změny parkovacího místa prosím uhraďte {{price}} {{currency}}.',
                    button: 'Uhradit změnu místa',
                },
            },
            documents: {
                tickets: 'Parkovací lístky',
                invoices: 'Faktury',
                invoiceCorrections: 'Opravné doklady',
                creditNotes: 'Vratky',
                other: 'Další dokumenty',
                termsOfService: 'Podmínky poskytování služeb',
                privacyPolicy: 'Zásady ochrany os. údajů',
                garageOperatingTerms: 'Provozní řád garáže',
            },
            active: {
                open: 'Otevřít',
                slideToOpen: 'Otevřete přejetím',
                entrance: 'vjezd',
                exit: 'výjezd',
                reception: 'recepci',
                extend: 'Prodloužit',
                cancel: 'Zrušit',
                confirm: 'Potvrdit',
                ending: 'Končí',
                starting: 'Začíná',
                ended: 'Skončila',
                cancelNotPossible: 'Vaši rezervaci není možné stornovat:',
                cancelSuccessful: 'Vaše rezervace byla úspěšně stornována.',
            },
            edit: {
                save: 'Uložit',
                cancel: 'Zrušit',
                clear: 'Vyčistit',
                phoneNumber1: 'Tel. číslo 1',
                phoneNumber2: 'Tel. číslo 2',
                licensePlate: 'SPZ',
            },
            cancel: {
                confirmation: 'Chcete stornovat tuto rezervaci?',
                detail: 'Po zrušení rezervace ji již nebude možné obnovit.',
                cancel: 'Stornovat rezervaci',
                keep: 'Zachovat',
            },
            empty: {
                title: 'Zatím jste neprovedli žádnou rezervaci',
                text: 'Vytvořte novou rezervaci. Všechny Vaše rezervace si pak budete moci prohlédnout přehledně zde.'
            },
            reportOccupiedUnit: {
                button: 'Obsazené místo',
                title: 'Nahlášení obsazeného místa',
                subtitle: 'Stojí Vám někdo na přiděleném místě? Vyplňte prosím údaje níže a situaci rychle vyřešíme.',
                buttonText: 'Nahlásit',
                cancel: 'Zrušit',
                offendantNumberPlate: 'SPZ vozu, který Vám stojí na místě',
                yourReservationNumber: 'Číslo Vaší rezervace',
                yourEmail: 'Váš email',
                stateCreated: 'Požadavek na změnu místa vytvořen',
                stateOpen: 'Požadavek na změnu místa v řešení',
                stateClosed: 'Požadavek na změnu místa vyřešen',
            },
        },
        profile: {
            refetch: 'Načíst znovu',
            languageSelector: 'Výběr jazyka',
            currencySelector: 'Výběr měny',
            signOut: 'Odhlásit se',
            userProfile: {
                title: "Profil uživatele",
                edit_title: "Upravit uživatelský profil",
                edit_save: "Upravit",
                email: "Email",
                userName: "Jméno a příjmení",
                phoneNumber1: "Telefon č.1",
                phoneNumber1Tooltip: "Slouží k otevření garáže",
                phoneNumber2: "Telefon č.2",
                agreedToMarketing: "Souhlas s marketingem",
                edit_agreedToMarketing: "Povolit marketing",
                prefillCheckoutInfo: "Předvyplňovat údaje v rezervaci",
                edit_prefillCheckoutInfo: "Předvyplňovat údaje v rezervaci",
            },
            invoiceDetails: {
                title: "Fakturační údaje",
                edit_title: "Upravit fakturační údaje",
                edit_save: "Upravit",
                empty: "Zatím nepřidáno",
                invoice_title: "Název firmy",
                invoice_street: "Ulice",
                invoice_city: "Město",
                invoice_zip_code: "PSČ",
                invoice_country: "Země",
                invoice_ic: "IČ",
                invoice_dic: "DIČ",
            },
            cars: {
                title: "Vozidla",
                edit_title: "Upravit vozidlo",
                edit_save: "Upravit",
                add_title: "Přidat vozidlo",
                add_confirm: "Přidat",
                name: "Název",
                numberPlate: "SPZ",
                color: "Barva",
                add: "Přidat"
            }
        },
        checkout: {
            actions: {
                back: 'Zpět',
                toPaymentCTA: 'K platbě',
            },
            cancellationAlert: {
                heading: 'Zrušení zdarma kdykoli před začátkem',
                bullet1: 'Rezervaci můžete bezplatně zrušit kdykoli před začátkem parkování.',
                bullet2: 'Zrušení provedete v aplikaci, přes odkaz v potvrzovacím e-mailu nebo kontaktováním zákaznické podpory.',
                bullet3: 'Po začátku rezervace již rezervaci zrušit nelze, a to ani částečně.',
            },
            unsupportedIosApp: {
                title: 'Pro pokračování aktualizujte MR.PARKIT',
                description: 'Tato verze aplikace MR.PARKIT již není podporována. Chcete-li vytvořit nebo zaplatit rezervaci, aktualizujte aplikaci na nejnovější verzi z App Storu.',
                updateApp: 'Aktualizovat v App Store',
            },
            errors: {
                expiredTitle: 'Platnost rezervace vypršela',
                expiredText: 'Tuto rezervaci už nelze dokončit. Vyberte si prosím znovu garáž a vytvořte novou rezervaci.',
                backToGarageList: 'Zpět na výběr garáží',
                unavailable: 'Checkout rezervace již není k dispozici. Vytvořte prosím novou rezervaci.',
            },
            booked: {
                title: 'Rezervace dokončena',
                text: 'Tato rezervace již byla uhrazena a je potvrzená.',
                myReservations: 'Přejít do mých rezervací',
            },
            paymentResolution: {
                checking: 'Kontrolujeme stav vaší platby. Vyčkejte prosím.',
            },
            termsOfServiceHtml: '<checkboxLabel>Žádám poskytnutí služby v termínu dle rezervace a souhlasím s </checkboxLabel><termsLink>Podmínkami poskytování služeb</termsLink><checkboxLabel>, s </checkboxLabel><privacyPolicyLink>Ochranou osobních údajů</privacyPolicyLink><checkboxLabel> a s </checkboxLabel><garageTermsLink>Provozním řádem garáže</garageTermsLink><checkboxLabel>.</checkboxLabel>',
            sendSms: 'Garáž již znám, nepotřebuji znovu instrukce do SMS a / nebo používám k otevření aplikaci.',
            disclaimer: {
                validation: {
                    required: 'Pro pokračování prosím potvrďte podmínky.',
                },
            },
            contactInfo: {
                heading: 'Kontakt',
                edit: 'Upravit',
                save: 'Uložit',
                cancel: 'Zrušit',
                clear: 'Vyčistit',
                name: 'Jméno a příjmení',
                email: 'E-mail',
                emailSuggestion: 'Neměli jste na mysli {{email}}?',
                phoneNumber1: 'Telefon č.1',
                phoneNumber2: 'Telefon č.2',
                invoiceHeading: 'Fakturační údaje',
                invoiceTitle: 'Název firmy',
                mandatoryInvoiceTitle: 'Jméno/Název firmy',
                invoiceStreet: 'Ulice',
                invoiceCity: 'Město',
                invoiceZipCode: 'PSČ',
                invoiceCountry: 'Země',
                countryNoOptions: 'Žádná odpovídající země',
                invoiceIc: 'IČ',
                invoiceDic: 'DIČ',
                addPhoneNumber: 'Přidat další telefon',
                additionalPhoneInfo: 'Tato čísla jsou autorizovaná pro otevření garáže voláním.',
                invoiceRequest: 'Nestačí mi běžný daňový doklad – potřebuji fakturu do firemního účetnictví.',
                validation: {
                    required: 'Vyplňte prosím toto pole.',
                    invalidEmail: 'Zadejte prosím platný e-mail.',
                    invalidPhone: 'Zadejte prosím platné telefonní číslo.',
                },
            },
            vehicleInfo: {
                heading: 'Vozidlo',
                edit: 'Upravit',
                save: 'Uložit',
                cancel: 'Zrušit',
                clear: 'Vyčistit',
                numberPlate: 'SPZ',
                carColor: 'Barva vozu',
                addNow: 'Přidám nyní',
                addLater: 'Přidám později',
                savedCarsLabel: 'Vyberte vozidlo',
                customOption: 'Jiné...',
                addLaterSelected: 'Přidám později v appce',
                addLaterDescription: 'SPZ vozidla můžete přidat v appce kdykoli před příjezdem.',
                validation: {
                    required: 'Vyplňte prosím toto pole.',
                },
            },
            discountCode: {
                // heading: 'Slevový kód',
                label: 'Slevový kód',
                apply: 'Aplikovat',
                addCode: 'Přidat slevový kód',
                changeCode: 'Zadat jiný',
                removeCode: 'Odstranit slevový kód',
                applied: 'Aplikován slevový kód {{code}}',
                appliedPercentage: 'Aplikován slevový kód {{code}} - {{discount}}% sleva',
                appliedAmount: 'Aplikován slevový kód {{code}} - sleva {{discount}} CZK',
                validation: {
                    required: 'Zadejte prosím slevový kód.',
                },
            },
            benefitCodePayment: {
                reveal: 'Rezervovat booking kódem',
                label: 'Booking kód',
                placeholder: 'Vyberte booking kód',
                submit: 'Rezervovat booking kódem',
                cancel: 'Zrušit',
                validation: {
                    required: 'Vyberte prosím booking kód.',
                },
            },
            extensionAlert: {
                heading_one: 'Rezervace prodloužena na {{count}}\u00a0hodinu',
                heading_few: 'Rezervace prodloužena na {{count}}\u00a0hodiny',
                heading_many: 'Rezervace prodloužena na {{count}}\u00a0hodiny',
                heading_other: 'Rezervace prodloužena na {{count}}\u00a0hodin',
                explanation: 'Rezervaci jsme Vám proto automaticky prodloužili.',
                until: 'Za stejnou cenu můžete parkovat až do {{endsAt}}.',
                untilMidnight: 'Za stejnou cenu můžete parkovat až do půlnoci.',
                untilWeekday: 'Za stejnou cenu můžete parkovat až do {{weekday}} {{endsAt}}.',
            },
            orderSummary: {
                start: 'Začátek',
                end: 'Konec',
                duration: 'Délka',
                originalPrice: 'Původní cena',
                discount: 'Sleva',
                total: 'Celkem',
                identificationNumber: 'IČ',
                vatPayer: 'Plátce DPH',
                notVatPayer: 'Neplátce DPH',
                vatIncluded: 'vč. DPH',
            },
            paymentResult: {
                missingPaymentId: 'Chybí identifikace platby.',
                missingReservationToken: 'Chybí kontext checkoutu. Vraťte se prosím do checkoutu a zkuste to znovu.',
                genericError: 'Platbu se nepodařilo spustit. Zkuste to prosím znovu.',
                redirectingToStripe: 'Přesměrování do Stripe…',
                continueToStripeHostedPayment: 'Pokračovat na Stripe-hosted platbu',
                continueToPayment: 'Pokračovat k platbě',
                backToHomepage: 'Zpět na úvodní stránku',
                backToCheckout: 'Zpět na checkout',
            },
        },
        success: {
            newsletterBanner: {
                title: 'Nenechte si ujít novinky a speciální akce',
                button: 'Odebírat novinky',
                success: 'Děkujeme za přihlášení k odběru.',
                error: 'Odběr novinek se nepodařilo aktivovat. Zkuste to prosím znovu.',
            },
            appBanner: {
                title: 'Parkujte ještě snadněji s naší mobilní aplikací',
                feature1: 'Snadná úprava nebo storno rezervace',
                feature2: 'Pohodlné otevření garáže tlačítkem místo volání',
                feature3: 'Ještě rychlejší rezervace bez opakovaného vyplňování údajů',
                feature4: 'Všechny účetní dokumenty na jednom místě',
                androidAlt: 'Instalovat na Android',
                iphoneAlt: 'Instalovat na iPhone',
                visualAlt: 'QR kód a ukázka mobilní aplikace Mr. Parkit',
            },
            congratulations: {
                title: 'Úspěšná rezervace! Děkujeme.',
                imageAlt: 'Ilustrační obrázek rezervace',
                text: 'Na uvedený e-mail jsme odeslali parkovací lístek s detaily Vaší rezervace. Pro Vaše pohodlí jsme Vám rovněž poslali vše v SMS na vámi uvedená telefonní čísla. Parkovací místo musí být uvolněno nejpozději do skončení rezervace!',
                textWithoutSms: 'Na uvedený e-mail jsme odeslali parkovací lístek s detaily Vaší rezervace. Vaši rezervaci můžete spravovat v sekci Moje rezervace. Parkovací místo musí být uvolněno nejpozději do skončení rezervace!',
                myReservationsLink: 'Pokračovat do moje rezervace',
            },
            prolongation: {
                congratulations: {
                    title: 'Rezervace byla úspěšně prodloužena',
                    imageAlt: 'Ilustrační obrázek úspěšného prodloužení rezervace',
                    text: 'Prodloužení rezervace bylo úspěšně potvrzeno. Aktualizované potvrzení vám pošleme e-mailem a SMS.',
                },
                failed: {
                    title: 'Prodloužení rezervace se nepodařilo dokončit',
                    text: 'Nepodařilo se potvrdit platbu za prodloužení rezervace. Zkuste to prosím znovu z detailu rezervace.',
                },
                pending: {
                    title: 'Čekáme na potvrzení platby za prodloužení',
                    imageAlt: 'Ilustrační obrázek čekajícího prodloužení rezervace',
                    text: 'Platba za prodloužení rezervace zatím nebyla potvrzena. Prosím, vyčkejte na dokončení.',
                },
                returnLink: 'Zpět na rezervaci',
            },
            changeUnit: {
                congratulations: {
                    title: 'Parkovací místo bylo úspěšně změněno',
                    imageAlt: 'Ilustrační obrázek úspěšné změny parkovacího místa',
                    text: 'Platba za změnu parkovacího místa byla potvrzena. Aktualizované potvrzení vám pošleme e-mailem a SMS.',
                },
                failed: {
                    title: 'Platbu za změnu parkovacího místa se nepodařilo dokončit',
                    text: 'Nepodařilo se potvrdit platbu za změnu parkovacího místa. Zkuste to prosím znovu z detailu rezervace.',
                },
                pending: {
                    title: 'Čekáme na potvrzení platby za změnu parkovacího místa',
                    imageAlt: 'Ilustrační obrázek čekající změny parkovacího místa',
                    text: 'Platba za změnu parkovacího místa zatím nebyla potvrzena. Prosím, vyčkejte na dokončení.',
                },
                returnLink: 'Zpět na rezervaci',
            },
            failed: {
                title: 'Rezervaci se nepodařilo dokončit.',
                imageAlt: 'Ilustrační obrázek nepovedené rezervace',
                text: 'Pravděpodobně došlo k příliš velkému prodlení při placení a rezervace Vám mezitím vyexpirovala. Platbu tímto stornujeme a peníze Vám vrátíme. Zkuste prosím rezervaci vytvořit znovu.',
                repeatLink: 'Zkusit znovu',
            },
            pending: {
                title: 'Čekáme na potvrzení platby',
                imageAlt: 'Ilustrační obrázek čekající rezervace',
                text: 'Platba zatím nebyla potvrzena. Prosím, počkejte na dokončení platby. Jakmile platbu potvrdíme, pošleme vám potvrzení e‑mailem a SMS.',
                repeatLink: 'Zkusit znovu',
            },
            summary: { 
                title: 'Potvrzení rezervace',
                continueToMyReservations: 'Pokračujte prosím do sekce Moje rezervace pro zobrazení detailu rezervace.',
                debugFetchErrorsIntro: 'Došlo k chybám při stahování detailu rezervace v tomto pohledu:',
            },
            reservationSummary: {
                totalPrice: 'Celkem:',
                vatIncluded: 'vč. DPH',
                email: 'E-mail',
                name: 'Jméno a příjmení',
                numberPlate: 'SPZ',
                carColor: 'Barva vozu',
                floorWithNumber:'Patro / Parkovací místo',
                phoneNumber:'Telefon',
                phoneNumber2:'Druhý telefon',
            }
        },
        garage: {
            car_dimensions: {
                title: 'Maximální rozměry',
                titleWithWeight: 'Maximální rozměry a hmotnost',
                height: 'Výška',
                length: 'Délka',
                weight: 'Hmotnost',
                width: 'Šířka',
            },
            showLess: 'Zobrazit méně',
            showMore: 'Zobrazit více',
            mainBenefits: {
                first: 'Opakovaný vjezd i výjezd',
                second: 'Instrukce v e-mailu a SMS',
                third: 'Snadné storno i změna rezervace',
            },
            openOnMap: "Navigovat",
            showInstructions: "Důležité pokyny",
            instructionsHeading: "Důležité pokyny k příjezdu/opuštění garáže",
            benefits: {
                title: 'Parametry',
                list: {
                    '10_minutes_form_city_center': 'Centrum města do 10 min',
                    '15_minutes_from_city_center': 'Centrum města do 15 min',
                    '5_minutes_form_city_center': 'Centrum města do 5 min',
                    call_reception: 'Po příjezdu prosím zavolejte na recepci.',
                    cctv: 'Kamerový systém',
                    cctv_at_entrance: 'Kamerový systém u vjezdu',
                    city_center: 'Centrum města ',
                    historic_city_center: 'Historické centrum města',
                    charging_station: 'Dobíjení pro elektromobily',
                    licence_plate_validation: 'Otevření závory čtením SPZ',
                    limited_vehicle_dimensions: 'Omezené rozměry vozu!',
                    main_reception:
                        'Pristup do garaze ziskate na hlavni recepci budovy ve vstupni hale - az pote lze vjet do garaze.',
                    nonstop_operation: 'Non-stop provoz',
                    nonstop_reception: 'Non-stop recepce',
                    nonstop_service: 'Non-stop provoz',
                    number_plate_recognition: 'Kamera přečte Vaši SPZ a otevře závoru',
                    open_gate_by_attendant: 'Vrata garáže Vám otevře recepční',
                    open_gate_by_phone: 'Vrata garáže otevíráte svým telefonem',
                    parking_for_disabled: 'Kamerový systém u vjezdu',
                    security_system: 'Bezpečnostní systém',
                    subway_availability: 'Tramvaj v blízkosti',
                    tram_availability: 'Metro v blízkosti',
                    wc: 'WC',
                },
            },
            prohibitions: {
                title: 'Zákazy',
                list: {
                    lpg_cng_not_allowed: 'LPG a CNG není povoleno',
                    electric_car_not_allowed: 'Zákaz parkování elektromobilů',
                    motorbikes_not_allowed: 'Zákaz parkování motorek',
                },
            },
            garage_videos: {
                title: 'Videogalerie',
            },
            faq: {
                title: 'Časté dotazy',
            },
            reservationSummary: {
                minimumStay: {
                    first: 'Minimální doba rezervace je zde',
                    second: 'hodin',
                },
            },
            confirmationModal: {
                maxDimensionsTitle: 'Upozornění',
                cancel: 'Zrušit',
                complete: 'Rezervovat',
            }
        },
        loginCrossroads: {
            login: "Přihlásit se",
            createAccount: "Vytvořit účet",
        },
        pwa: {
            search: 'Hledat',
            myReservations: 'Moje rezervace',
            profile: 'Profil',
            myReservationsNoUser: 'Pro správu rezervací a otevírání garáží je třeba se přihlásit:',
            profileNoUser: 'Pro správu profilu, vozidel a fakturace je třeba se přihlásit:'
        },
        error: {
            heading: ':(',
            title: 'Došlo k neočekávané chybě zobrazení',
            titleEmbedded: 'V této záložce došlo k neočekávané chybě v zobrazení - zbytek aplikace pravděpodobně bez problému funguje.',
            textEmbedded: 'Zkuste prosím přejít do jiné záložky, popřípadě aplikaci restartovat. Můžete nás také kontaktovat přes web, rádi Vám pomůžeme.',
            moreInfo: 'Zde je více informací pro vývojáře:'
        },
        support: {
            heading: 'Kontakt',
            text: 'Jsme k dispozici Po-Pá 9:00-17:00. Mimo pracovní dobu Vám na hotline pomůžeme pouze s urgentním problémem u právě probíhající rezervace.',
            more: 'Více',
        },
    },
}
